import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'rt-loading-game-frame',
  template: `<iframe [src]="iframeUrl()" sandbox="allow-scripts" class="game-frame"></iframe>`,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
      .game-frame {
        border: none;
        width: 100%;
        height: 300px;
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingGameFrameComponent {
  private readonly sanitizer = inject(DomSanitizer);

  public readonly startText = input.required<string>();
  public readonly tutorialText = input.required<string>();
  public readonly gameOverText = input.required<string>();
  public readonly scoreText = input.required<string>();

  public readonly iframeUrl = computed((): SafeResourceUrl => {
    const params = new URLSearchParams({
      startText: this.startText(),
      tutorialText: this.tutorialText(),
      gameOverText: this.gameOverText(),
      scoreText: this.scoreText(),
    });
    // eslint-disable-next-line ban/ban
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `assets/images/tellent-skills/loading-game.html?${params}`,
    );
  });
}
